import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const IMPORT_USAGE_QUERY_KEY = ["import-usage"] as const;

export type ImportUsageResponse = components["schemas"]["ImportUsageResponse"];

/**
 * Current-month import-operation usage for the signed-in tenant (ADR 0026 D4).
 * Drives the "N of M imports used this month" line on the Import page.
 */
export function useImportUsage() {
  const client = useApiClient();
  return useQuery({
    queryKey: IMPORT_USAGE_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await client.GET("/api/imports/usage");
      if (error !== undefined) {
        throw new Error("Failed to load import usage");
      }
      return data;
    },
  });
}
